import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  Input,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { InputNumberModule } from "primeng/inputnumber";
import {
  SystemParam,
  SystemParamSubject,
} from "src/app/shared/models/order.model";
import { BroshService } from "src/app/shared/services/brosh.service";

@Component({
  selector: "param-box",
  templateUrl: "./param-box.component.html",
  styleUrls: ["./param-box.component.scss"],
  standalone: true,
  imports: [CommonModule, TranslateModule, InputNumberModule, FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParamBoxComponent implements OnInit {
  @Input() subject: SystemParamSubject;
  editSw: boolean;

  constructor(
    private broshService: BroshService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {}

  save() {
    let isDirty = this.subject.params.filter((p) => p.dirtySw).length > 0;
    if (isDirty) {
      this.broshService.updateSystemParams(this.subject).subscribe(() => {
        this.editSw = false;
        this.subject.params.map((p) => (p.dirtySw = false));
        this.cdr.markForCheck();
      });
    } else {
      this.editSw = false;
    }
  }

  onValueChanged(param: SystemParam) {
    param.dirtySw = true;
  }
}
